import styled from 'styled-components'

export const Centered = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`



// WEBPACK FOOTER //
// ./src/components/HeroProduct/styles.js